const errors = {
  PRODUCT_LIMIT_EXCEEDED: 'You have reached the maximum of products in your current plan.',
  USER_LIMIT_EXCEEDED: 'You have reached the maximum number of users in your current plan.',
  'auth/user-not-found': 'Wrong email or password',
  COMPANY_DATA_INVALID: 'You company data is not complete yet.',
  'auth/wrong-password': 'Wrong email or password',
};

export default errors;
